/*
  Header cart count after an add to cart.

  Adding to the cart, from a product card, the product page or anywhere else,
  goes through the cart drawer script: it posts the form, redraws the drawer
  and opens it, or goes to the cart page when the drawer is set not to open. It
  does not touch the header. The header refreshes its own count whenever the
  contents of #cart-icon-bubble are replaced, which is how the platform reports
  a new cart count, so this file supplies that replacement and nothing more.

  No request is added. The drawer script already asks the cart API to render a
  list of sections with every cart change; the cart icon section is put on that
  list, and its markup is read back from the payload the drawer script
  announces once the change has landed.
*/

(() => {
  // Loaded by every section that renders kv-cart-behavior (the cart drawer,
  // kv-cart-drawer, and the cart page, kv-cart-main) and by every product
  // card, so later copies stop here.
  if (window.kvCartCountReady) return;
  window.kvCartCountReady = true;

  const SECTION_ID = 'cart-icon-bubble';

  // The drawer script reads the same shared object when it posts, so a section
  // listed here is rendered in the response to every cart change.
  const config = (window.kvCartConfig = window.kvCartConfig || { sections: [] });
  if (!Array.isArray(config.sections)) config.sections = [];
  if (!config.sections.includes(SECTION_ID)) config.sections.push(SECTION_ID);

  document.addEventListener('kv-cart:updated', (event) => {
    const cart = event.detail && event.detail.cart;
    const markup = cart && cart.sections && cart.sections[SECTION_ID];
    const bubble = document.getElementById(SECTION_ID);
    if (!bubble || typeof markup !== 'string') return;

    // The rendered section arrives wrapped in its section element; only the
    // inside belongs in the header.
    const fresh = new DOMParser()
      .parseFromString(markup, 'text/html')
      .querySelector('.shopify-section');
    if (fresh) bubble.innerHTML = fresh.innerHTML;
  });
})();
